(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("maishu-chitu"), require("react-dom"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["maishu-chitu", "react-dom", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("maishu-chitu"), require("react-dom"), require("react")) : factory(root["maishu-chitu"], root["react-dom"], root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof window === 'undefined' ? global : window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 